import { Tabs } from 'components-antd';
import { useState } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { History } from '../History';
import { Documents } from '../Documents';
import { isExternalMember } from '../../../FormsTable/helper';
import { FormsTableStatus } from 'app-constants';
import { TrackingTab } from './TrackingTab';

export const FormDetailTabs = (props) => {
  const {
    formDetails,
    disableSections,
    selectedFormProcess,
    selectedFormStatus,
    handleViewForm,
    isDraftForm,
  } = props;

  const [activeKey, setActiveKey] = useState('Tracking');

  const tabItems = [
    {
      key: 'Tracking',
      label: 'Tracking',
      children: <TrackingTab {...props} />,
    },
    {
      key: 'Files',
      label: 'Files',
      children: formDetails?.formDocuments?.length ? (
        <Documents
          documentData={formDetails?.formDocuments}
          formProcessDocuments={formDetails?.formProcessDocuments}
          handleViewForm={handleViewForm}
          selectedFormProcess={selectedFormProcess}
          disableViewForm={!!isExternalMember(formDetails)}
          showFormDate={!isDraftForm}
          isCompleted={formDetails?.isCompleted}
          formDetails={formDetails}
        />
      ) : (
        <></>
      ),
    },
    {
      key: 'History',
      label: 'History',
      children: (
        <History
          history={formDetails?.historyLogs}
          createdBy={formDetails?.createdBy}
          isFormOwner={formDetails?.isOwner}
        />
      ),
    },
  ];

  return (
    <div
      className={classNames(styles.formDetailTabsWrapper, { [styles.disabled]: disableSections })}
    >
      <Tabs
        activeKey={activeKey}
        size="middle"
        items={tabItems}
        className={styles.formDetailTabs}
        onChange={(tab) => setActiveKey(tab)}
      />
      {disableSections && <div className={styles.overlaySheet} />}
    </div>
  );
};
